export const CONTAINER_PREFIX = 'CONTAINER-'
export const TEMPORARY_ID_PREFIX = '-'
